/* Announcement rotator: one visible item, auto-advance, prev/next, pause on hover, reduced-motion aware. */
(function () {
function initBar(root) {
  if (!root || root.dataset.init) return; root.dataset.init = '1';
  var items = root.querySelectorAll('.rs-announcement__item');
  if (items.length < 2) return;
  var i = 0, timer, interval = (parseFloat(root.dataset.interval) || 3.5) * 1000, speed = (parseFloat(root.dataset.speed) || 0.3) * 1000;
  var rtl = root.dataset.direction !== 'ltr';
  items.forEach(function (it, k) { if (k !== 0) { it.setAttribute('aria-hidden', 'true'); it.inert = true; } });
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.style.setProperty('--rs-ann-speed', (reduce ? 0 : speed) + 'ms');
  function go(next, back) {
    var cur = items[i]; var nxt = items[next]; if (cur === nxt) return;
    var out = (rtl !== !!back) ? 'is-out-left' : 'is-out-right'; var from = (rtl !== !!back) ? 'is-in-right' : 'is-in-left';
    nxt.classList.add(from, 'is-active'); cur.classList.add(out); cur.classList.remove('is-active');
    cur.setAttribute('aria-hidden', 'true'); cur.inert = true; nxt.removeAttribute('aria-hidden'); nxt.inert = false; /* R-21 */
    requestAnimationFrame(function () { requestAnimationFrame(function () { nxt.classList.remove(from); }); });
    setTimeout(function () { cur.classList.remove(out); }, speed + 50);
    i = next;
  }
  function next() { go((i + 1) % items.length, false); }
  function prev() { go((i - 1 + items.length) % items.length, true); }
  function start() { stop(); timer = setInterval(next, interval); root._rsTimer = timer; }
  function stop() { if (timer) clearInterval(timer); timer = null; }
  root.querySelector('.rs-announcement__btn--next').addEventListener('click', function () { next(); start(); });
  root.querySelector('.rs-announcement__btn--prev').addEventListener('click', function () { prev(); start(); });
  root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  start();
}
initBar(document.querySelector('.rs-announcement'));
document.addEventListener('shopify:section:load', function (e) { initBar(e.target && e.target.querySelector('.rs-announcement')); });
document.addEventListener('shopify:section:unload', function (e) { var r = e.target && e.target.querySelector('.rs-announcement'); if (r && r._rsTimer) clearInterval(r._rsTimer); });
})();
